import { motion, useScroll, useSpring } from "framer-motion";

/**
 * Thin clay progress bar that fills as the page scrolls. Sits just under
 * the fixed navbar.
 */
export default function ScrollProgress() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 120,
    damping: 30,
    restDelta: 0.001,
  });

  return (
    <motion.div
      style={{ scaleX }}
      className="fixed left-0 right-0 top-0 z-[60] h-[2px] origin-left bg-clay"
    />
  );
}
